import { get, omit } from 'lodash';
import { CLEAR_PAGE } from '../base/types';
import { FETCH_CENTERS, UPDATE_CENTERS, DELETE_CENTERS, CREATE_CENTERS, CREATE_CENTER_SERVICE, UPDATE_CENTER_SERVICE, DELETE_CENTER_SERVICE, CREATE_CENTER_SERVICE_PRICE, UPDATE_CENTER_SERVICE_PRICE, DELETE_CENTER_SERVICE_PRICE } from './types';

const INIT_STATE = {
  isLoading: false,
  isLoaded: false,
  centers: { byId: {}, allIds: [] },
  services: {},
  servicesDescriptions: {},
};

const centersReducer = (state = INIT_STATE, { type, payload }) => {
  switch (type) {
    case `${FETCH_CENTERS}_PENDING`:
      return {
        ...state,
        isLoading: true,
      };
    case `${FETCH_CENTERS}_FULFILLED`:
      return {
        ...state,
        ...payload,
        isLoaded: true,
        isLoading: false,
      };
    case `${FETCH_CENTERS}_REJECTED`:
      return {
        ...state,
        isLoaded: true,
        isLoading: false,
      };

    case `${CREATE_CENTERS}_FULFILLED`:
      return {
        ...state,
        centers: {
          allIds: [...get(state, ['centers', 'allIds'], []), payload.id],
          byId: { ...get(state, ['centers', 'byId'], {}), [payload.id]: payload },
        },
      };
    case `${UPDATE_CENTERS}_FULFILLED`:
      return {
        ...state,
        centers: {
          ...get(state, ['centers']),
          byId: {
            ...get(state, ['centers', 'byId'], {}),
            [payload.id]: {
              ...get(state, ['centers', 'byId', payload.id], {}),
              ...omit(payload, ['services']),
            },
          },
        },
      };
    case `${DELETE_CENTERS}_FULFILLED`:
      return {
        ...state,
        centers: {
          allIds: get(state, ['centers', 'allIds'], []).filter((i) => Number(i) !== Number(payload?.id)),
          byId: { ...get(state, ['centers', 'byId'], {}), [payload.id]: undefined },
        },
      };

    case `${CREATE_CENTER_SERVICE}_FULFILLED`:
      return {
        ...state,
        services: { ...get(state, ['services'], {}), [payload.id]: payload },
        centers: {
          ...get(state, ['centers']),
          byId: {
            ...get(state, ['centers', 'byId'], {}),
            [payload.center]: {
              ...get(state, ['centers', 'byId', payload.center], {}),
              services: [...get(state, ['centers', 'byId', payload.center, 'services'], []), payload.id],
            },
          },
        },
      };
    case `${UPDATE_CENTER_SERVICE}_FULFILLED`:
      return {
        ...state,
        services: {
          ...get(state, ['services'], {}),
          [payload.id]: {
            ...get(state, ['services', payload.id], {}),
            ...omit(payload, ['service_descriptions']),
          },
        },
      };
    case `${DELETE_CENTER_SERVICE}_FULFILLED`:
      return {
        ...state,
        services: { ...get(state, ['services'], {}), [payload.id]: undefined },
        centers: {
          ...get(state, ['centers']),
          byId: {
            ...get(state, ['centers', 'byId'], {}),
            [payload.centerId]: {
              ...get(state, ['centers', 'byId', payload.centerId], {}),
              services: get(state, ['centers', 'byId', payload.centerId, 'services'], []).filter((i) => Number(i) !== Number(payload?.id)),
            },
          },
        },
      };

    case `${CREATE_CENTER_SERVICE_PRICE}_FULFILLED`:
      return {
        ...state,
        servicesDescriptions: { ...get(state, ['servicesDescriptions'], {}), [payload.id]: payload },
        services: {
          ...get(state, ['services'], {}),
          [payload.service]: {
            ...get(state, ['services', payload.service], {}),
            service_descriptions: [...get(state, ['services', payload.service, 'service_descriptions'], []), payload.id],
          },
        },
      };
    case `${UPDATE_CENTER_SERVICE_PRICE}_FULFILLED`:
      return {
        ...state,
        servicesDescriptions: {
          ...get(state, ['servicesDescriptions'], {}),
          [payload.id]: payload,
        },
      };
    case `${DELETE_CENTER_SERVICE_PRICE}_FULFILLED`:
      return {
        ...state,
        servicesDescriptions: { ...get(state, ['servicesDescriptions'], {}), [payload.id]: undefined },
        services: {
          ...get(state, ['services'], {}),
          [payload.serviceId]: {
            ...get(state, ['services', payload.serviceId], {}),
            service_descriptions: get(state, ['services', payload.serviceId, 'service_descriptions'], []).filter((i) => Number(i) !== Number(payload?.id)),
          },
        },
      };

    case CLEAR_PAGE:
      return payload === 'centers' ? INIT_STATE : state;

    default:
      return state;
  }
};

export default centersReducer;
